import dealerFeatures from './dealerFeatures';
import mapIcons from './mapIcons';
import weather from './weather';

export default {
  dealerFeatures,
  mapIcons,
  weather,
};



// WEBPACK FOOTER //
// ./src/assets/images/index.js